<template>
    <section class="home-latest-article-section py-5">
    <div class="container">
        <div class="row">
            <div v-for="article in articles" :key="article.nid" class="col-12 col-lg-4">
                <div class="news-block-his text-center position-relative">
                    <div class="news-image">
                        <img v-bind:src="article.field_basic_image" alt="" class="img-fluid position-relative">
                    </div>
                    <div class="bible-book-his bg-white rounded-circle">
                        <img src="front-bible-book-icon-by-vexels.png" class="img-fluid">
                    </div>
                    <div class="news-content-his border">
                        <h5>{{article.title}}</h5>
                        <p>{{article.body_1.substring(0,27)+".."}}</p>
                        <router-link :to="{ name: 'SingleDetail', params: { id: article.current_path }}" class="btn text-white rounded-0 px-4">Read More</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </section>
</template>

<script>
    import axios from 'axios';

    export default{
        name: 'News',
        data () {
            return {
                info: null,
                articles:[]
            }
        },
        mounted() {
            axios
                .get('https://api.fifmi.org.au/api/articles')
                .then(result => {
                    for (var i = 0; i < result.data.length; i++) {
                        if(result.data[i].field_domain_access.includes('fifmi') && result.data[i].type == "article"){
                            result.data[i].current_path = result.data[i].current_path.split('/').pop();
                            this.articles.push(result.data[i]);
                        }
                    }
                });
        },
    }
</script>
